import { useCallback } from 'react';
import { omit } from 'lodash-es';
import { parse } from 'query-string';
import { useHistory } from 'react-router';

export const useRemoveParams = () => {
  const history = useHistory();

  const removeParams = useCallback(
    (params: string[]) => {
      const searchParams = new URLSearchParams(
        omit(parse(window.location.search), params) as Record<string, string>
      );

      history.replace({
        search: searchParams.toString(),
      });
    },
    [history]
  );

  return removeParams;
};
